import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthShell, Field, inputCls } from "@/components/nadia/AuthShell";
import { useAuth } from "@/lib/auth";
import { authLogin, formatApiError } from "@/lib/api";

export default function Accedi() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login, user } = useAuth();
  const nav = useNavigate();
  const next = params.get("next") || "/app";

  useEffect(() => { if (user) nav(user.email_verified ? next : "/verifica-email", { replace: true }); }, [user, nav, next]);
  useEffect(() => {
    const t = params.get("verify");
    if (t) nav(`/verifica-email?token=${encodeURIComponent(t)}`, { replace: true });
  }, [params, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await authLogin(email, password);
      login(r.token, r.account);
      toast.success(`Bentornato, ${r.account.name}`);
      nav(r.account.email_verified ? next : "/verifica-email", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err, "Accesso non riuscito"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Accesso"
      title="Accedi a Nadia Cloud"
      subtitle="Nadia riprende da dove eravate rimasti."
      footer={<>Non hai un account? <Link to="/registrati" className="text-cyan-300 hover:text-cyan-200" data-testid="login-go-register">Registrati</Link> · Prima <Link to="/" className="text-slate-300 hover:text-slate-100">richiedi un’analisi gratuita</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="Email"><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className={inputCls} placeholder="nome@azienda.it" data-testid="login-email" /></Field>
        <Field label="Password"><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className={inputCls} placeholder="La tua password" data-testid="login-password" /></Field>
        <div className="flex justify-end -mt-1">
          <Link to="/password-dimenticata" className="text-xs text-slate-400 hover:text-cyan-200" data-testid="login-forgot">Password dimenticata?</Link>
        </div>
        <Button type="submit" disabled={busy} className="w-full h-12 bg-gradient-to-r from-cyan-400 to-violet-500 hover:from-cyan-300 hover:to-violet-400 text-slate-950 font-semibold rounded-xl" data-testid="login-submit">
          {busy ? <Loader2 size={16} className="mr-2 animate-spin" /> : <LogIn size={16} className="mr-2" />} Accedi
        </Button>
      </form>
    </AuthShell>
  );
}
